import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  FETCH_UNVALIDATED_PERIODS_REQUEST,
  fetchUnvalidatedPeriodsSuccess,
} from '../actions/fetchUnvalidatedPeriodsActions';
import PeriodsAPI from '../api/PeriodsAPI';
import { accessTokenSelector, buildServerSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* unvalidatedPeriodsWatcher() {
  yield takeLatest(FETCH_UNVALIDATED_PERIODS_REQUEST, unvalidatedPeriodsWorker);
}

function* unvalidatedPeriodsWorker(action) {
  const { courseGuid } = action;
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(buildServerSelector);
    const periods = yield call(PeriodsAPI.buildPeriodsFor, builder, accessToken);
    yield put(fetchUnvalidatedPeriodsSuccess({ courseGuid, periods }));
  } catch (error) {
    yield fork(manageAPIError, { ...error, action });
  }
}

export { unvalidatedPeriodsWorker };
export default unvalidatedPeriodsWatcher;
